import { axios } from '@/lib/axios';

export const APIgetFileCredentials = (tenantId: string, filename: string, storageId: string): Promise<any> => {
    return axios.get(`/tenant/${tenantId}/file/credentials`, {
        params: {
            filename,
            storageId
        }
    });
};
